import React, { useContext } from 'react'
import { ComparisonStyles } from './Style'
import { VersionsContext } from './VersionsContext'
import { wordHooks, WordList } from 'pages/Words'
import { statuses, types } from 'keys'

const Comparison = (props) => {
    const { wrongVersion1Words, assessmentVersion1, assessmentVersion2, wrongWords2, wrongWords1 } = props
    const assessmentCategory = wordHooks.useAssessmentCategory()
    let categoryVersion1 = assessmentCategory[assessmentVersion1?.category || "DEFAULT"]

    return (
        <ComparisonStyles>
            <div className='words' style={{ display: "flex" }}>
                <div className='version-words'>
                    <div className='checker-name'>{assessmentVersion1.data?.marking_words_update_by}</div>
                    {wrongWords1 &&
                        <WordList
                            wordsPerLine={1}
                            category={categoryVersion1}
                            words={wrongWords1}
                        />}
                </div>
                <div className='version-words'>
                    <div className='checker-name'>{assessmentVersion2.data?.marking_words_update_by}</div>
                    {wrongWords2 &&
                        <WordList
                            wordsPerLine={1}
                            category={categoryVersion1}
                            words={wrongWords2}
                        />}
                </div>
            </div>
        </ComparisonStyles>
    )
}

export default Comparison